onReady(() => {
    const jobBoard = document.querySelector('.greenhouse-job-board')
    if (!jobBoard) {
        return
    }
    const emptyStateContainer = jobBoard.querySelector('.empty-state')
    const departmentFilter = jobBoard.querySelector('#jobs-department-filter')
    const officeFilter = jobBoard.querySelector('#jobs-office-filter')
    const departmentSections = Array.from(jobBoard.querySelectorAll('.jobs-by-department'))
    const jobPosts = Array.from(jobBoard.querySelectorAll('.job-post'))

    const changeUrlParameters = (parameters) => {
        const newUrl = new URL(window.location)

        for (const param in parameters) {
            if (!Object.hasOwnProperty.call(parameters, param)) {
                continue
            }

            // remove parameters if they are set to show all
            if (parameters[param] === 'all') {
                newUrl.searchParams.delete(param)
                continue
            }

            // Update filter value in URL
            newUrl.searchParams.set(param, parameters[param])
        }

        // Update URL without refreshing the page
        window.history.pushState({path: newUrl.toString()}, '', newUrl.toString())
    }

    const filterJobPosts = (event) => {
        if (event) {
            event.target.blur()
        }
        const department = departmentFilter.value
        const office = officeFilter ? officeFilter.value : 'all'

        // Reset visibility of elements
        jobPosts
            .concat(departmentSections)
            .forEach((element) => element.classList.remove('hidden'))
        emptyStateContainer.classList.add('hidden')

        // Update URL to reflect the filters
        changeUrlParameters({department, office})

        if (department === 'all' && office === 'all') {
            // No filtering required
            return
        }

        if (department !== 'all') {
            // Hide department sections that do not match the filter
            departmentSections.forEach(
                (section) => section.classList.toggle('hidden', section.dataset.department !== department),
            )
        }

        if (office !== 'all') {
            // Hide job posts that do not match the office filter
            // TODO support multiple offices
            jobPosts.forEach(
                (job) => job.classList.toggle('hidden', !job.dataset.office.includes(office)),
            )
        }

        // Hide department sections if there's no visible job-post
        departmentSections.forEach(
            (section) => section.querySelector('.job-post:not(.hidden)') || section.classList.add('hidden'),
        )

        // Show empty state if nothing is visible
        if (!departmentSections.find((section) => !section.classList.contains('hidden'))) {
            emptyStateContainer.classList.remove('hidden')
        }
    }

    const closeJobPost = (jobPost, toggleButton) => {
        // Toggle the button text
        toggleButton.text = 'Read more'

        // Open job post details
        jobPost.classList.remove('open')

        // Remove job from URL
        const newUrl = new URL(window.location)
        newUrl.hash = ''
        window.history.pushState(null, '', newUrl.toString());
    }
    const openJobPost = (jobPost, toggleButton) => {
        const applicationFormFrame = jobPost.querySelector('.post-details iframe')

        // Load the iframe with the application form url
        if (!applicationFormFrame.src) {
            applicationFormFrame.src = jobPost.dataset.applicationFormUrl
        }

        // Toggle the button text
        toggleButton.text = 'Close'

        // Open job post details
        jobPost.classList.add('open')

        // Scroll to open post
        const extraSpace = 35
        const siteNotice = document.querySelector('.site-notice')
        const navContainer = document.querySelector('.navigationcontainer')
        const scrollOffset = (siteNotice ? siteNotice.offsetHeight : 0) + navContainer.offsetHeight + extraSpace
        window.scroll(0, findYPos(jobPost) - scrollOffset)

        // Update URL
        const newUrl = new URL(window.location)
        newUrl.hash = `#${jobPost.dataset.id}`
        window.history.pushState(null, '', newUrl.toString());
    }
    const toggleJobPostDrawer = (jobPost, toggleButton) => {
        // Close if open
        if (jobPost.classList.contains('open')) {
            return closeJobPost(jobPost, toggleButton)
        }

        // Close currently open job post
        const currentlyOpenJobPost = jobBoard.querySelector('.job-post.open')
        if (currentlyOpenJobPost) {
            closeJobPost(currentlyOpenJobPost, toggleButton)
        }

        openJobPost(jobPost, toggleButton)
    }

    // Trigger filtering when any of the filter values change
    departmentFilter.addEventListener('change', filterJobPosts)
    if (officeFilter) {
        officeFilter.addEventListener('change', filterJobPosts)
    }

    // Add job post toggle button listeners
    for (const jobPost of jobPosts) {
        const toggleButton = jobPost.querySelector('.apply-button')
        toggleButton.addEventListener('click', (event) => {
            event.preventDefault()
            toggleJobPostDrawer(jobPost, toggleButton)
            toggleButton.blur()
        })
    }

    // Apply any filters present in the URL
    const requestParametes = new URLSearchParams(window.location.search)
    departmentFilter.value = requestParametes.get('department') || 'all'
    if (officeFilter) {
        officeFilter.value = requestParametes.get('office') || 'all'
    }
    if (requestParametes.has('department') || requestParametes.has('office')) {
        filterJobPosts()
    }

    // Open job, if present in URL
    if (location.hash) {
        const jobId = location.hash.slice(1)
        const selectedJob = jobBoard.querySelector(`.job-post[data-id="${jobId}"]`)
        if (!selectedJob) {
            return
        }
        openJobPost(selectedJob, selectedJob.querySelector('.apply-button'))
    }
});
